import { render, staticRenderFns } from "./Imeis.vue?vue&type=template&id=72912ef8&"
import script from "./Imeis.vue?vue&type=script&lang=js&"
export * from "./Imeis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports